import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { GeneralService } from '../services/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-branches',
  templateUrl: './add-branches.component.html',
  styleUrls: ['./add-branches.component.scss']
})
export class AddBranchesComponent implements OnInit {
  AddBranchForm: FormGroup;
  clients: any;
  clientstofilter: any;
  dataSource: any;
  displayedColumns: string[] = [
    "BranchName",
    "Adress",
    "BranchPhone",
    "action",
  ];
  companynameFormControl = new FormControl("", [Validators.required]);

  usernameFormControl = new FormControl("", [Validators.required]);

  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  form = {
    companyname: "",
    username: "",
    email: "",

  };
  data: object[] = [];
  update: boolean;
  BranchId: any;
  editmode: boolean;
  ClientId: any;
  constructor(private _formBuilder: FormBuilder,    public GeneralService: GeneralService, 
) { 

  const UserInfo=JSON.parse(localStorage.getItem('currentuser'));
  this.ClientId=UserInfo.clientid;
 console.log(UserInfo);
 
}
 

   
  initForm() {
    this.AddBranchForm = this._formBuilder.group({
      BranchName: [ '', Validators.required],
      Address: ['', Validators.required],
      Phone: ['', Validators.required],
    });
  }
  getallBranches(){
    this.clients=[];
    this.GeneralService.getbranchesbyclientid(this.ClientId).then(clients=>{
      this.clients=clients;
      this.clientstofilter=clients
      console.log(this.clients)
    })
  }
  get fc() {
    return this.AddBranchForm.controls;
  }
  ngOnInit() {
    this.initForm();
    this.getallBranches();
  }
  InsertBranch(){
    const data= {
"name":this.AddBranchForm.get("BranchName").value,
"address":this.AddBranchForm.get("Address").value,
"clientid":this.ClientId,
"phonenumber":this.AddBranchForm.get("Phone").value,
    }
    this.GeneralService.addBranchForClient(data).then(res=>{
      Swal.fire({
        icon: "success",
        title: "Success Add Branch ",
        showConfirmButton: false,
        timer:1000
      });
      this.getallBranches();
      this.AddBranchForm.reset();

    })
  }
  addbranch(){
    console.log(this.AddBranchForm.value)
    if (this.AddBranchForm.status == "VALID") {
   
        this.InsertBranch()
      
    }
     else {
      this.AddBranchForm.markAllAsTouched();
    }
  }
  Edit(item){
    console.log(item)
    this.BranchId=item.id
    this.editmode=true
  this.AddBranchForm.get("BranchName").setValue(item.name)
  this.AddBranchForm.get("Address").setValue(item.address)
  this.AddBranchForm.get("Phone").setValue(item.phonenumber)
  }
  
    UpdateBranch(){
      if (this.AddBranchForm.status == "VALID") {
   
        const data= {
          "name":this.AddBranchForm.get("BranchName").value,
          "address":this.AddBranchForm.get("Address").value,
          "clientid":this.ClientId,
          "phonenumber":this.AddBranchForm.get("Phone").value,
              }
            this.GeneralService.UpdateBranch(data,this.BranchId).then((res)=>{
              this.AddBranchForm.reset()
            this.editmode = false;
            Swal.fire({
              icon: "success",
              title: "Success Update Branch ",
              showConfirmButton: false,
              timer:1000
            });
            }).then(r=>{
              this.getallBranches();
            })
      
    }
     else {
      this.AddBranchForm.markAllAsTouched();
    }
     
  }

  DeleteBranch(item){
    Swal.fire({
      title: " Warning !",
      text: "Are you sure to delete this Branch",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#7364f6',
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
      cancelButtonText: "Back",
    }).then((result) => {
      if (result.isConfirmed) {
        this.GeneralService.DelBranch(item.id).subscribe(success => {
          if (success) {
            this.getallBranches();
            Swal.fire({
              icon: "success",
              title: "Success Branch Deleted",
              showConfirmButton: false,
              timer:1000
            });
          } else {
            console.log("User could not be removed due to quota limits or other errors.");
          }
        });
      } else {
        // Swal.fire(
        //   'Your appointment still active ',
        // );
      }
    });
  }
  onNoClick(): void {
    // this.dialogRef.close();
  }
}
